// extracted by mini-css-extract-plugin
export default {"loginInput":"FormLogin_loginInput__S1ua9","LoginForm":"FormLogin_LoginForm__L1Hps"};